import React from 'react';
import Parser from 'html-react-parser';
import { R } from '@core/utils/r';
import { WithTooltip } from '@modules/common';
import { HTMLService } from '../html_service';

export function getGlossaryContent(htmlContent: string) {
  return Parser(htmlContent, {
    replace: domNode => {
      if (R.get(domNode, 'attribs.class', '').includes('glossary-word')) {
        const tooltip = R.get(domNode, 'attribs.data-definition');
        const word = R.get(domNode, 'children[0].data');
        return (
          <WithTooltip
            tooltip={
              <span>
                <h6 className="text-white mb-0" style={{ fontWeight: 700 }}>
                  {word}
                </h6>
                <br className="m-0" />
                {HTMLService.toReact(atob(tooltip))}
              </span>
            }
            placement="right"
          >
            <span style={{ borderBottom: '3px  solid lightgray', cursor: 'pointer' }}>{word}</span>
          </WithTooltip>
        );
      }
      return domNode;
    },
  });
}
